import React, { useEffect, useRef } from 'react'
import Floatingbutton from './Floatingbutton'
import PageHeader from '../Elements/UI/PageHeader'
import EmptyState from '../Elements/UI/EmptyState'
import FeedSkeleton from '../Elements/UI/FeedSkeleton'
import FeedTime from '../Elements/UI/FeedTime'
import DeleteButton from '../Elements/UI/DeleteButton'
import Opentimelinemodal from '../Modals/Opentimelinemodal'
import Conformationmodal from '../Modals/Conformetionmodal'
import { connect } from 'react-redux'
import axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'
import UpdatesCard from './SmallComponents/UpdatesCard'

function Timeline({ userAccess = [] }) {
  const wideBlockRef = useRef()
  const [showModal, setShowModal] = React.useState(false)
  const [selectId, setSelectId] = React.useState(null)
  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [timelineData, setTimelineData] = React.useState([])
  const [inputData, setInputData] = React.useState([])

  useEffect(() => {
    fetchmyposts().finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteTimeline = pollID => {
    setDeleteId(pollID)
    setShowConfirmModal(true)
  }

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  const handleConfirmDelete = async () => {
    if (!deleteId) return
    const token = localStorage.getItem('token')
    try {
      await axios.delete(`${config.apiUrl}/post/${deleteId}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      setTimelineData(prev => prev.filter(item => item.pollId !== deleteId))
      toast.success('Post deleted successfully!')
      setShowConfirmModal(false)
      setDeleteId(null)
    } catch (e) {
      console.error(e)
      toast.error('Failed to delete post')
    }
  }

  const fetchmyposts = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(`${config.apiUrl}/post/getAll/Updates`, {
        headers: { Authorization: token }
      })

      const normalized = (res.data.data || [])
        .filter(post => post.Type === 'Updates')
        .map(post => {
          let imageUrl = ''
          if (post?.Data?.ImageLink) {
            if (
              typeof post.Data.ImageLink === 'object' &&
              post.Data.ImageLink.data
            ) {
              imageUrl = String(post.Data.ImageLink.data)
            } else if (typeof post.Data.ImageLink === 'string') {
              imageUrl = post.Data.ImageLink
            }
          }
          return {
            pollId: post.ID,
            type: post.Type,
            title: post?.Data?.Title || '',
            image: imageUrl,
            CreatedOn: post.CreatedOn,
            ...post
          }
        })
        .sort((a, b) => b.pollId - a.pollId)
      setTimelineData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  // Uploads an image or video; onProgress receives 0–100
  const ImageUploadtimeliene = async (formData, onProgress) => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.post(`${config.apiUrl}/upload/image`, formData, {
        headers: {
          Authorization: token
        },
        onUploadProgress: e => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100))
        }
      })
      if (res.status === 200) {
        return res.data
      }
    } catch (e) {
      console.error('Media upload failed', e)
      toast.error('Upload failed. Please try again.')
    }
  }

  const Postupload = async payload => {
    const token = localStorage.getItem('token')

    try {
      const postRes = await axios.post(
        `${config.apiUrl}/post/Updates`,
        payload,
        {
          headers: { Authorization: token }
        }
      )

      if (postRes.status === 200) {
        const apiPost = postRes.data?.data

        let imageUrl = ''
        if (apiPost?.Data?.ImageLink) {
          if (
            typeof apiPost.Data.ImageLink === 'object' &&
            apiPost.Data.ImageLink.data
          ) {
            imageUrl = apiPost.Data.ImageLink.data
          } else if (typeof apiPost.Data.ImageLink === 'string') {
            imageUrl = apiPost.Data.ImageLink
          }
        } else if (payload?.Data?.ImageLink?.data) {
          imageUrl = payload.Data.ImageLink.data
        }

        const newPost = {
          pollId: apiPost?.ID || Date.now(),
          type: apiPost?.Type || 'Updates',
          title: apiPost?.Data?.Title || payload.Data.Title || 'Untitled',
          image: imageUrl,
          CreatedOn: apiPost?.CreatedOn || new Date().toISOString(),
          Data: {
            Title: apiPost?.Data?.Title || payload.Data.Title,
            MediaType: apiPost?.Data?.MediaType || payload?.Data?.MediaType,
            ImageLink: imageUrl ? (typeof imageUrl === 'object' ? imageUrl : { data: imageUrl }) : payload?.Data?.ImageLink
          },
          ID: apiPost?.ID,
          Type: 'Updates',
          ...apiPost
        }

        setTimelineData(prev => [newPost, ...prev])
        toast.success('Post created successfully!')
        setShowModal(false)
      }
    } catch (e) {
      console.error('Post upload failed', e)
      toast.error('Failed to create post')
    }
  }
  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  const canDelete = Array.isArray(userAccess) && userAccess.includes('DeleteTimeline')

  return (
    <div id="appCapsule">
      <div className="section full mt-1">
        <div className="wide-block mt-1" ref={wideBlockRef}>
          <PageHeader title="Project layout & designs" subtitle="Floor plans, elevations and design updates" />

          {loading && <FeedSkeleton label="Loading designs" />}

          {!loading && (!Array.isArray(timelineData) || timelineData.length === 0) && (
            <EmptyState icon="hourglass-outline" title="No designs shared yet" text="New items will appear here once they are posted." />
          )}

          <div className="timeline timed">
            {timelineData.map(item => (
              <div className="item" key={item.pollId}>
                <FeedTime value={item.CreatedOn} />

                <div className={`dot ${item.dotColor}`} aria-hidden="true"></div>
                <div className="content">
                  <article className={`card bl-feed-card${canDelete ? ' has-action' : ''}`}>
                    {canDelete && (
                      <DeleteButton onClick={() => handleDeleteTimeline(item.pollId)} label="Delete design" />
                    )}
                    <UpdatesCard item={item} />
                  </article>
                </div>
              </div>
            ))}
          </div>

          {userAccess.includes('CreateTimeline') && (
            <Floatingbutton onOpen={handlemodalOpen} />
          )}

          <Opentimelinemodal
            show={showModal}
            id={selectId}
            onImagetimeline={ImageUploadtimeliene}
            onSubmitpost={Postupload}
            inputData={inputData}
            fetchinputs={fetchinputs}
            onClose={() => setShowModal(false)}
          />

          <Conformationmodal
            show={showConfirmModal}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  userAccess: auth.userAccess
})

export default connect(mapStateToProps)(Timeline)
